<template slot-scope="scope">
  <!-- 开票记录表格组件 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="订单ID" align="center" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="消费类型"
          align="center"
          width="130"
          
        >
          <template slot-scope="scope">
            <span>{{ getConsumptionTypeName(scope.row.consumptionType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="服务内容"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.serviceContent }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发票总额（元）" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.total }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="发票性质" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="发票类型" align="center" width="130">
          <template slot-scope="scope">
            <span>{{
              scope.row.attribute == 0
                ? "增值税普通发票"
                : scope.row.attribute == 1
                ? "增值税专用发票"
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发票状态" align="center" >
          <template slot-scope="scope">
            <span
              :style="
                scope.row.status == '1'
                  ? 'color:#409eff ;'
                  : scope.row.status == '2'
                  ? 'color: #FE574A;'
                  : scope.row.status == '3'
                  ? 'color: #FE574A;'
                  : scope.row.status == '4'
                  ? 'color: #409eff ;'
                  : 'color: #FFA200;'
              "
              >{{
                scope.row.status == "1"
                  ? "成功"
                  : scope.row.status == "2"
                  ? "失败"
                  : scope.row.status == "3"
                  ? "作废"
                  : scope.row.status == "4"
                  ? "成功"
                  : "正在审核"
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="驳回原因" align="center"  show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.note }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <span
              class="table-p"
              @click="handleDetail(scope.$index, scope.row)"
              style="margin-right: 10px;"
              >开票详情</span
            >
            <span
              v-if="scope.row.canReissue"
              class="table-p"
              @click="handleEdit(scope.$index, scope.row)"
              >重新开票</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ticketDialog
      :dialogVisible="dialogVisible"
      :num="num"
      :acquiesce="acquiesce"
      :headList="dataOption.headList"
      :mailList="dataOption.mailList"
      :addressList="dataOption.addressList"
      :isReissue="true"
      :isBatch="false"
      @handleCloseDele="handleCloseDele"
      @handleUnderstand="handleUnderstand"
    ></ticketDialog>
  </div>
</template>

<script>
// 引入接口
import {
  getDefaultHeadAndMailInfo, // 代开发票获取默认抬头与地址邮箱
  getInvoiceHeadAndMailInfo, //查看发票相关信息，发票抬头，邮寄地址，电子邮箱地址
  reIssueInvoice, //重新开票
} from "../../../../../assets/api/firm/firmCenter";
import ticketDialog from "./ticketDialog.vue";
export default {
  props: {
    // deviceList: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
    tableData: {},
    select: {},
    verifyData: {}, // 法人信息 是否实名认证等  用于开票前判断
  },
  components: {
    ticketDialog,
  },
  data() {
    return {
      tableKey: "",
      multipleSelection: [], //多选
      dialogVisible: false, // 开票弹窗
      num: "", // 消费类型
      reopenId: "", // 重新代开发票
      acquiesce: {}, // 设置的默认
      dataOption: {}, // 抬头/地址/邮箱  选项
    };
  },
  computed: {},
  created() {},
  methods: {
    //关闭弹窗
    handleCloseDele() {
      this.dialogVisible = false;
    },
    // 弹窗确认
    handleUnderstand(val, unlockConfirm) {
      const unlock =
        typeof unlockConfirm === "function" ? unlockConfirm : null;
      // 重新开票
      var data = {
        data: {
          id: this.reopenId, // 开票记录id
          type: Number(val.listArrSelect), //0电子1纸质
          headId: val.value, //抬头id
          attribute: Number(val.listArrSelect1), //0普通增值税发票1专用
          mailOrAddressId:
            val.listArrSelect == 0
              ? val.sendMail == 1
                ? val.value1
                : ""
              : val.value2, //邮箱/地址
          showFlag: val.showFlag, //是否展示 0否 1是
          sendMail: val.sendMail, //是否发送邮箱 0否 1是
          renewReason: val.renewReason, //重开原因
        },
      };
      reIssueInvoice(data)
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.dialogVisible = false;
            this.$nextTick(() => {
              this.$emit("Refresh");
            });
          }
        })
        .finally(() => {
          unlock && unlock();
        });
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取消费类型名称
    getConsumptionTypeName(type) {
      const typeMap = {
        0: '道具',
        1: '代理服务',
        2: '充值',
        3: '增值',
        4:'广告服务'
      };
      return typeMap[type] || '-';
    },
    // 开票详情
    handleDetail(index, row) {
      this.$emit("handleDetail", row);
    },
    // 代开发票
    handleEdit(index, row) {
      if (this.verifyData.auditStatus == 3) {
        this.reopenId = row.id;
        this.num = row.consumptionType; // 获取消费类型
        // 获取所属发票抬头列表 接口 (代开发票弹窗中使用)
        this.getDefaultHeadAndMailInfo();
        this.getInvoiceHeadAndMailInfo();
        setTimeout(() => {
          this.dialogVisible = true;
        }, 100);
      } else {
        this.$tool.PromptBox("warning", "请先在企业安全管理中进行实名认证！");
      }
    },
    //获取默认的地址/邮箱/抬头 接口
    async getDefaultHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
        },
      };
      // 获取默认的地址/邮箱/抬头 接口
      const res1 = await getDefaultHeadAndMailInfo(data);
      this.acquiesce = res1.data;
    },
    //  获取 抬头/地址/邮箱  数据传给弹窗用于选择
    async getInvoiceHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 1, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getCompany.id, //开票主体id
        },
      };
      const res = await getInvoiceHeadAndMailInfo(data);
      this.dataOption = res.data;
    },

    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">

.table-p {
  display: inline-block;
  width: 80px;
  height: 26px;
  border-radius: 5px;
  background: #409eff ;
  text-align: center;
  color: #ffffff;
  line-height: 26px;
  cursor: pointer;
  user-select: none;
}

/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(9) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
